<template>
   <CCard>      
      <CCardBody>       
           <CRow>      
          <CCol sm="6" lg="6" >  
            <div style="text-align: center; font-size: 15px; border-style:solid; border-color: #ced2d8; border-width:0.5px;border-bottom-width:0px; padding-top: 6px; padding-bottom: 6px;">原物料</div>
            <div class="content-wrapper">                            
              <div id="app">  
                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='ckgrid' locale='zh-TW' :dataSource='this.ck_datas' height='550' 
                    :allowExcelExport='true' :allowPaging='false' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :allowSelection='true'
                    :queryCellInfo='onQueryCellInfo' :toolbar='ck_toolbar' :beforeRender="beforeRender" :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                    :toolbarClick="toolbarClick"  :rowSelected='rowSelected'>                             
                    <e-columns> 
                        <e-column field='no' headerText='原物料編號' width='120'></e-column>                          
                        <e-column field='name' headerText='原物料名稱' width='200'></e-column>                     
                    </e-columns>
                  </ejs-grid>        
                </ejs-tooltip>
              </div>                  
            </div>                
          </CCol>
           
          <CCol sm="6" lg="6" >  
            <div style="text-align: center; font-size: 15px; border-style:solid; border-color: #ced2d8; border-width:0.5px;border-bottom-width:0px; padding-top: 6px; padding-bottom: 6px;">檢驗內容</div>
            <div class="content-wrapper">                            
              <div id="app">    
                <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                  <ejs-grid ref='ckitemgrid' locale='zh-TW' :dataSource='this.ckitem_datas' height='550' 
                    :allowExcelExport='true' :allowPaging='false' :allowSorting='true' :allowFiltering='true' :allowReordering='true' :allowSelection='true'
                    :queryCellInfo='onQueryCellInfo' :toolbar='ckitem_toolbar' :beforeRender="beforeRender" :filterSettings='filterSettings' :selectionSettings2='selectionSettings' 
                    :toolbarClick="toolbarClick" :dataBound="onGridDataBound">                             
                    <e-columns>       
                        <e-column type='checkbox' field='check' :allowFiltering='false' :allowSorting='false' width='60'></e-column>            
                        <e-column field='content_id' headerText='檢驗編號' width='120' :isPrimaryKey='true' ></e-column>                          
                        <e-column field='content_name' headerText='檢驗名稱' aria-required="true" :isPrimaryKey='true' width='200'></e-column>   
                    </e-columns>
                  </ejs-grid>        
                </ejs-tooltip>
              </div>                  
            </div>                
          </CCol>
        </CRow>     
        <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>    

      </CCardBody>
   </CCard>
</template>

<style lang="scss" src="../../scss/grid.scss"></style>
<script>
  
import Vue from "vue";
import { GridComponent, ColumnDirective, ColumnsDirective, Page, Sort, Toolbar, Edit, Filter, ExcelExport } from "@syncfusion/ej2-vue-grids";
import { L10n, enableRipple  } from '@syncfusion/ej2-base';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { NumericTextBoxPlugin } from '@syncfusion/ej2-vue-inputs';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import zhtwLocalization  from '../language/language.json';

L10n.load(zhtwLocalization);
Vue.use(TooltipPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DialogPlugin);
enableRipple(true);
Vue.prototype.$eventHub = new Vue(); 

export default {
  components: {
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-toast': ToastComponent,
  },
  provide : {
    grid: [Page, Sort, Toolbar, Edit, Filter, ExcelExport], 
      
  },
  name: 'acceptance_scm',
  data: function() {
    return {
        e_ck_selectData : null, 
        is_add: false,
        ck_datas : [],
        ckitem_datas : [],            
        dropDownFields: { text: 'text', value: 'value' },
     
        editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false }, 
        ck_toolbar: [ 
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'CheckExport' }, 'Search'],   
        ckitem_toolbar: [             
          { text: '確認', tooltipText: '確認', prefixIcon: 'e-btn-icon e-circle-check e-icons e-icon-left', id: 'CheckItemConfirm', disabled: localStorage.getItem('system').indexOf('42') < 0 },          
          { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'CheckItemExport' }, 'Search'],   
        selectionSettings : { type: 'Multiple', persistSelection: true },
        selectionSettings2: { persistSelection: true },
        
        filterSettings: { type: 'CheckBox' },   
        position: { X: 'Right', Y: "Bottom" },
 
      };
  },
  methods: {    
    onload:function() {
      // 初始化
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;                
      }
    },
    rowSelected: function(args) {      
      this.e_ck_selectData = args.data;  
      this.getCheckItem();
    },      
    load: function() {   

    },       
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },   
    toolbarClick: function(args) {
        
      if (args.item.id == "CheckExport") {
        this.$refs.ckgrid.excelExport({ fileName:'檢驗內容.xlsx' });
      }
      if (args.item.id == "CheckItemConfirm") {    
        if (this.e_ck_selectData == null) {
          this.showMsg('請先選擇檢驗內容');
          return;
        }
        
        let grid = this.$refs.ckitemgrid.ej2Instances;
        let select = grid.getSelectedRecords(); // ✅ 拿到勾選的資料

        this.confirmCheckItem(select);
        console.log(select);
      }
     
      if (args.item.id == "CheckItemExport") {
         this.$refs.ckitemgrid.excelExport({ fileName:'檢驗紀錄.xlsx' });
      }
    },   
    actionComplete: function() {                             
    },  
    getCheck: function() {    
      this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/CheckManager/Maintains`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.e_ck_selectData = null;
        this.ck_datas = response.data.datas;
        this.getCheckItem();
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },      
    getCheckItem: function() {    
      this.axios({
        method: 'get',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: this.e_ck_selectData == null ? `/CheckManager/Content` : `/CheckManager/Content?material_id=${encodeURIComponent(this.e_ck_selectData.no)}`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }                 
        this.ckitem_datas = response.data.datas.content;
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },       
    onGridDataBound: function() {       
      setTimeout(() => {   
        var row = [];
        for(var v in this.ckitem_datas) {
          if (this.ckitem_datas[v].check) {
            row.push(parseInt(v));
          }
        }
        this.$refs.ckitemgrid.ej2Instances.selectRows(row); 
        this.e_ckitem_selectData = null;
      }, 50);

    },    
    confirmCheckItem: function(datas) {     
      this.axios({
        method: 'put',
        baseURL: Vue.prototype.GLOBAL.baseURL,
        url: `/CheckManager/Maintains`,
        headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
        data : {
          no : this.e_ck_selectData.no,
          datas : datas
        }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('已確認檢驗紀錄');                
      })
      .catch((error) => { 
        this.showError(error) }
      )             
    },       

    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showError: function (error) {     
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
  },

  created() {
    this.getCheck();
  },

  mounted() {
   
  },
  beforeUpdate() {
    
  },
  beforeDestroy() {
   
  }  
}
</script>

<style scoped>
  .box {
    border-style:solid; 
    border-color: #ced2d8; 
    border-width:1px;
    border-top-width:0px; 
    padding-top: 6px; 
    padding-bottom: 6px;
    border-left-width: 0px;
    display: flex;
    align-items: center;  
  }
  .box-header {
    border-style:solid; 
    border-color: #ced2d8; 
    border-width:1px;
    border-top-width:0px; 
    padding-top: 16px; 
    padding-bottom: 16px;
    border-left-width: 0px;
  }
</style>
<style lang="scss" src="../../scss/base.scss"></style>